// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="r4">R4</h2>
      <p>This <a href="https://www.hl7.org/fhir/r4/coverageeligibilityresponse.html">CoverageEligibilityResponse</a> resource is compliant with FHIR version R4 standards; more information regarding VA’s implementation of this resource can be found in the <a href="/explore/health/docs/urgent_care">Urgent Care API</a>.</p>
    </div>
  );
};

export default MarkdownComponent;
